export const isRequired = (field) => field && field.Active === 1
export const getName = (field) => field && field.FName

export const normalizeIBAN = () => (value, prevValue) => {
  if (!/^[a-zA-Z0-9]+$/.test(value) && value) {
    return prevValue
  }

  return value
}

export const handlePreventAction = (event) => {
  event.preventDefault()
}

export const normalizeCardNumber = (cardTypeFieldName, type?: 0 | 1, ID?: number) => (value, prevValue, values) => {
  const cardType = values[cardTypeFieldName]

  if (type === 1) {
    if ([1, 2, 3].indexOf(parseInt(cardType, 10)) !== -1) {
      if (!/^[0-9]+$/.test(value) && value) {
        return prevValue
      }
    }
  }
  if (type === 0 && ID !== 6) {
    if (!/^[0-9a-zA-Z]*$/.test(value)) {
      return prevValue
    }
  }

  return value
}
